export default [
    {
        path: '/giderGruplar',
        name: 'giderGruplar',
        component: () => import('@/views/gider/giderGrup.vue'),
        meta: {
            pageTitle: 'Gider Grupları',
            icon: 'StarIcon',
            breadcrumb: [
                {
                    first: 'Giderler',
                    second: 'Gider Grupları',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/giderListesi/:id',
        name: 'giderListesi',
        component: () => import('@/views/gider/giderListe.vue'),
        meta: {
            pageTitle: 'Gider Listesi',
            icon: 'StarIcon',
            breadcrumb: [
                {
                    first: 'Giderler',
                    second: 'Gider Listesi',
                    active: true,
                },
            ],
        },
    },
]
